const PHONE = "5512991688576";

export const waLink = (message) =>
    `https://wa.me/${PHONE}?text=${encodeURIComponent(message)}`;

export const WHATSAPP_URL = waLink(
    "Olá, Yasmim! Vim pelo seu site e quero agendar um horário.",
);

export const INSTAGRAM_URL = "https://www.instagram.com/yasmimal_nails";
export const INSTAGRAM_HANDLE = "@yasmimal_nails";
export const PHONE_DISPLAY = "+55 12 99168-8576";
export const ADDRESS =
    "Rua Pedro Cabral Barbosa, 58 — Perequê-Mirim, Ubatuba/SP · CEP 11680-000";
export const MAPS_URL =
    "https://www.google.com/maps/search/?api=1&query=Rua+Pedro+Cabral+Barbosa,+58,+Perequ%C3%AA-Mirim,+Ubatuba,+SP,+11680-000";
export const MAPS_EMBED =
    "https://www.google.com/maps?q=Rua%20Pedro%20Cabral%20Barbosa%2C%2058%2C%20Perequ%C3%AA-Mirim%2C%20Ubatuba%2C%20SP%2C%2011680-000&output=embed";

export const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -72, duration: 1.5 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};

export const IMAGES = {
    hero: "/hero-yasmim.jpg",
    about: "https://images.unsplash.com/photo-1636928332625-8cfc200fbbd6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
};

export const GALLERY = [
    {
        src: "https://images.unsplash.com/photo-1743594789385-323b38491cdc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000&auto=format&fit=crop",
        alt: "Esmaltação em tom nude elegante",
        caption: "Nude editorial",
        tall: true,
        wide: true,
    },
    {
        src: "https://images.unsplash.com/photo-1679931992412-a3f2ae2691ea?crop=entropy&cs=srgb&fm=jpg&q=85&w=900&auto=format&fit=crop",
        alt: "Nail art autoral em detalhes",
        caption: "Nail art autoral",
        tall: false,
        wide: false,
    },
    {
        src: "https://images.unsplash.com/photo-1721206625114-e0266b71d141?crop=entropy&cs=srgb&fm=jpg&q=85&w=900&auto=format&fit=crop",
        alt: "Unhas com acabamento glossy",
        caption: "Brilho espelhado",
        tall: true,
        wide: false,
    },
    {
        src: "https://images.unsplash.com/photo-1618606679166-7f313aa5b26f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900&auto=format&fit=crop",
        alt: "Alongamento em gel formato amendoado",
        caption: "Alongamento em gel",
        tall: false,
        wide: false,
    },
    {
        src: "https://images.unsplash.com/photo-1633394443519-985dc90457db?crop=entropy&cs=srgb&fm=jpg&q=85&w=900&auto=format&fit=crop",
        alt: "Atmosfera do studio",
        caption: "O studio",
        tall: true,
        wide: false,
    },
    {
        src: "https://images.unsplash.com/photo-1604654894611-6973b376cbde?crop=entropy&cs=srgb&fm=jpg&q=85&w=900&auto=format&fit=crop",
        alt: "Coleção de esmaltes premium",
        caption: "Cores da estação",
        tall: false,
        wide: false,
    },
];

export const SERVICE_CATEGORIES = [
    {
        title: "Manicure & Pedicure",
        note: "O clássico impecável, com cuticulagem precisa e acabamento caprichado.",
        items: [
            { name: "Pé e Mão", price: "R$ 75" },
            { name: "Pé simples", price: "R$ 40" },
            { name: "Mão simples", price: "R$ 35" },
            { name: "SPA dos pés", price: "R$ 30" },
        ],
    },
    {
        title: "Aplicação",
        note: "Alongamentos e banho de gel com estrutura sob medida.",
        items: [
            { name: "Alongamento Molde F1", price: "R$ 190" },
            { name: "Alongamento Fibra de Vidro", price: "R$ 190" },
            { name: "Banho de Gel", price: "R$ 150" },
        ],
    },
    {
        title: "Esmaltação & Adicionais",
        note: "Cores, brilhos e os detalhes que fazem a diferença.",
        items: [
            { name: "Esmaltação simples", price: "R$ 15" },
            { name: "Esmaltação em gel", price: "R$ 30" },
            { name: "Mão com esmalte em gel", price: "R$ 65" },
            { name: "Pé com esmalte em gel", price: "R$ 70" },
            { name: "Francesinha", price: "R$ 5" },
            { name: "Pó cromado", price: "R$ 5" },
            { name: "Adesivo (par)", price: "R$ 5" },
            { name: "Pedraria (par)", price: "R$ 5" },
        ],
    },
    {
        title: "Manutenção & Remoção",
        note: "Para manter tudo impecável por muito mais tempo.",
        items: [
            { name: "Manutenção de Alongamento", price: "R$ 120" },
            { name: "Manutenção de Banho de Gel", price: "R$ 120" },
            { name: "Reposição na manutenção (cada)", price: "R$ 10" },
            { name: "Reposição de unha de gel (cada)", price: "R$ 15" },
            { name: "Remoção de Alongamento", price: "R$ 30" },
            { name: "Remoção de esmalte em gel", price: "R$ 15" },
            { name: "Reconstrução de unha do pé (cada)", price: "R$ 20" },
        ],
    },
];

export const INSTAGRAM_POSTS = [
    {
        src: "https://images.unsplash.com/photo-1743594789385-323b38491cdc?crop=entropy&cs=srgb&fm=jpg&q=85&w=600&auto=format&fit=crop",
        alt: "Post do Instagram: esmaltação nude",
    },
    {
        src: "https://images.unsplash.com/photo-1679931992412-a3f2ae2691ea?crop=entropy&cs=srgb&fm=jpg&q=85&w=600&auto=format&fit=crop",
        alt: "Post do Instagram: nail art autoral",
    },
    {
        src: "https://images.unsplash.com/photo-1721206625114-e0266b71d141?crop=entropy&cs=srgb&fm=jpg&q=85&w=600&auto=format&fit=crop",
        alt: "Post do Instagram: brilho espelhado",
    },
    {
        src: "https://images.unsplash.com/photo-1618606679166-7f313aa5b26f?crop=entropy&cs=srgb&fm=jpg&q=85&w=600&auto=format&fit=crop",
        alt: "Post do Instagram: alongamento em gel",
    },
    {
        src: "https://images.unsplash.com/photo-1633394443519-985dc90457db?crop=entropy&cs=srgb&fm=jpg&q=85&w=600&auto=format&fit=crop",
        alt: "Post do Instagram: bastidores do studio",
    },
    {
        src: "https://images.unsplash.com/photo-1636928332625-8cfc200fbbd6?crop=entropy&cs=srgb&fm=jpg&q=85&w=600&auto=format&fit=crop",
        alt: "Post do Instagram: atendimento no studio",
    },
];

export const NAV_LINKS = [
    { id: "servicos", label: "Serviços" },
    { id: "contato", label: "Contato" },
];
